var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"4"}},[_c('create-prd-cat')],1),_c('v-col',{attrs:{"cols":"8"}},[_c('table-prd-cat')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }